
  var _styles = {
  "comprehensive-card-photo-container": {
    "position": "relative",
    "width": "2.58667rem",
    "maxHeight": "4.90667rem"
  },
  "comprehensive-card-photo-img": {
    "position": "absolute",
    "width": "2.58667rem",
    "height": "4.90667rem"
  },
  "comprehensive-card-photo-tag-container": {
    "position": "absolute",
    "height": "0.42667rem",
    "paddingLeft": "0.06667rem",
    "paddingRight": "0.06667rem",
    "marginRight": "auto",
    "borderRadius": "0.24rem 0 0.16rem 0",
    "backgroundColor": "red",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "comprehensive-card-photo-tag": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "lineHeight": "0.36rem"
  },
  "comprehensive-card-photo-bottom-tag-container": {
    "bottom": 0,
    "width": "2.58667rem",
    "position": "absolute",
    "left": 0
  },
  "comprehensive-card-photo-bottom-tag": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.29333rem",
    "color": "rgb(142,60,18)",
    "letterSpacing": 0
  }
};



  module.exports = _styles;
  